var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUseronwhiteopt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 576.25,
    height: 541.97,
    viewBox: "0 0 576.25 541.97",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m239 0c-78.806 0-143 64.204-143 143 0 78.796 64.194 143 143 143s143-64.204 143-143c0-78.796-64.194-143-143-143zm-50.699 304c-103.8 0-188.3 84.491-188.3 188.3 0 27.249 22.406 49.67 49.66 49.67h378.68c24.428 0.0383 44.956-17.993 48.949-41.373-3.641 0.28575-7.3187 0.43554-11.031 0.43554-77.142 0-140-62.858-140-140 0-18.082 3.4525-35.38 9.7344-51.268-14.816-3.7606-30.322-5.7656-46.289-5.7656h-101.4z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fill: "#fff",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      imageRendering: "auto",
      isolation: "auto",
      mixBlendMode: "normal",
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m466.25 251.03c-60.929 0-110 49.071-110 110 0 60.929 49.071 110 110 110 60.929 0 110-49.071 110-110 0-60.929-49.071-110-110-110z",
    style: {
      fill: "#0a4",
      paintOrder: "fill markers stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m524.6 301.93a15.002 15.002 0 0 0-12.453 6.3672l-57.635 79.479-37.531-32.637a15.002 15.002 0 1 0-19.686 22.639l49.898 43.389a15.002 15.002 0 0 0 21.986-2.5137l67.254-92.744a15.002 15.002 0 0 0-11.834-23.979z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fill: "#fff",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      imageRendering: "auto",
      isolation: "auto",
      mixBlendMode: "normal",
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseronwhiteopt);
export default __webpack_public_path__ + "static/media/user.on.white.opt.b8dfe5416d993fa18cf8dd33bde04f62.svg";
export { ForwardRef as ReactComponent };